/** สถานะบิล POS — label, badge variant, accent สำหรับ UI */
export function statusLabel(s: string): string {
  switch (s) {
    case "paid":
      return "ຊຳລະແລ້ວ";
    case "draft":
      return "ຄ້າງຊຳລະ";
    case "voided":
      return "ຍົກເລີກ";
    case "refunded":
      return "ຄືນເງິນ";
    case "partial":
      return "ຊຳລະບາງສ່ວນ";
    default:
      return s;
  }
}

export function saleStatusBadgeVariant(s: string) {
  switch (s) {
    case "paid":
      return "success" as const;
    case "draft":
      return "warning" as const;
    case "voided":
      return "destructive" as const;
    case "refunded":
      return "info" as const;
    case "partial":
      return "accent" as const;
    default:
      return "secondary" as const;
  }
}

/** สี accent แถบซ้ายของแถวรายการ */
export function saleStatusRowAccent(s: string): string {
  switch (s) {
    case "paid":
      return "border-l-emerald-500";
    case "draft":
      return "border-l-amber-500";
    case "voided":
      return "border-l-destructive";
    case "refunded":
      return "border-l-sky-500";
    case "partial":
      return "border-l-violet-500";
    default:
      return "border-l-border";
  }
}

export const POS_SALE_STATUS_OPTIONS = [
  { value: "__all__", label: "ທັງໝົດ" },
  { value: "paid", label: "ຊຳລະແລ້ວ" },
  { value: "draft", label: "ຄ້າງຊຳລະ" },
  { value: "partial", label: "ຊຳລະບາງສ່ວນ" },
  { value: "voided", label: "ຍົກເລີກ" },
  { value: "refunded", label: "ຄືນເງິນ" },
  // ກອງຕາມ pos_returns.type (ບໍ່ແມ່ນ status) — ຄືນ/ປ່ຽນ ສິນຄ້າ
  { value: "returned", label: "ຄືນ" },
  { value: "exchanged", label: "ປ່ຽນ" },
] as const;
